import { drupal } from "@/lib/drupal/drupal"
import { DrupalBlockProductAnnouncement, DrupalTaxonomyTermProduct } from "@/types"
import { DrupalJsonApiParams } from "drupal-jsonapi-params"
import { Body } from "../wysiwyg/Body"
import { StatusMessage } from "../wysiwyg/StatusMessage"

export const ProductNotifications = async ({product}: {
  product: DrupalTaxonomyTermProduct
}) => {
  const params = new DrupalJsonApiParams()
  params.addFilter('field_products.id', product.id, 'IN')
  params.addFilter('field_publication_date', getCurrentTimeInUTC(), '<=')
  params.addFilter('field_depublication_date', getCurrentTimeInUTC(), '>')

  const notifications = await drupal.getResourceCollection<DrupalBlockProductAnnouncement[]>('block_content--product_notice', {params: params.getQueryObject()})

  return <div className="max-w-4xl">
    {notifications.map(block => <StatusMessage key={block.id} type={block.field_status} heading={block.field_title} dismissId={block.field_dismissible ? block.id : block.field_dismissible}>
      <Body value={block.body.processed} />
      </StatusMessage>)}
  </div>
}

function getCurrentTimeInUTC() {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * 60000; // Offset in milliseconds
  const localISOTime = new Date(now.getTime() - timezoneOffset).toISOString().slice(0, -5); // Remove milliseconds and Z
  return localISOTime;
}